import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import MedicinesCenterActions, { MedicinesCenterRedux, MedicinesCenterTypes } from '../Redux/MedicinesCenterRedux'
import { notificationSuccess, notificationFail } from '../Redux/NotificationActions'

const MedicineCRUDObservable = createCRUDObservable({
  mainRedux: MedicinesCenterRedux,
  reduxPath: 'medicines_center',
  dataHandlers: {
    get: response => response.data,
  },
})

const applyMedicineEpi = (action$, store, { Api }) =>
  action$.ofType(MedicinesCenterTypes.applyMedicineRequest)
    .mergeMap(({ medicine_id, apply_info }) => (
      Observable
        .fromPromise(Api.medicines_center.applyMedicine(medicine_id, apply_info)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló el proceso')]
          }
          const { data } = response
          return [
            MedicinesCenterActions.applyMedicineSuccess(medicine_id, data),
            notificationSuccess('Proceso realizado con exito '),
          ]
        })
    ))

const deleteMedicineEpi = (action$, store, { Api }) =>
  action$.ofType(MedicinesCenterTypes.deleteMedicineRequest)
    .mergeMap(({ medicine_id }) => (
      Observable
        .fromPromise(Api.medicines_center.deleteMedicine(medicine_id)
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló el proceso')]
          }
          const { data } = response
          return [
            MedicinesCenterActions.deleteMedicineSuccess(medicine_id),
            notificationSuccess('Proceso realizado con exito '),
          ]
        })
    ))

export const MedicineObservers = Object.assign({}, MedicineCRUDObservable.observers, {})
export const medicinesCenterEpic = combineEpics(
  MedicineCRUDObservable.epic,
  applyMedicineEpi,
  deleteMedicineEpi
)



// WEBPACK FOOTER //
// ./src/Data/Observables/MedicinesCenterObservable.js